import "@vitejs/plugin-react/preamble";
import { QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createAdminQueryClient } from "./admin-query";
import { App } from "./App";
import "@fontsource-variable/manrope";
import "./styles.css";

const queryClient = createAdminQueryClient();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
